<template>
  <div class="container mt-3">
    <div class="jumbotron">
      <form @submit.prevent="add" autocomplete="off">
        <div class="form-group">
          <label for="courseTitle">Titolo corso</label>
          <input required v-model="course.title" type="text" class="form-control" id="courseTitle" placeholder="Titolo">
        </div>
        <div class="form-group">
          <label for="courseDescription">Descrizione</label>
          <div id="editor">
            <quill-editor id="courseDescription" class="form-control" :config="editorOption" v-model="course.description"></quill-editor>
          </div>
        </div>
        <div class="form-group">
          <label for="courseTldr">Riassunto</label>
          <textarea v-model="course.tldr" class="form-control" id="courseTldr" placeholder="TLDR"></textarea>
        </div>
        <!-- Upload immagine profilo -->
        <div v-if="crop" class="form-group">
          <label for="courseImage">Immagine profilo</label>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Upload</span>
            </div>
            <div class="custom-file">
              <input type="file" v-on:change="onFileChange" class="custom-file-input" id="inputGroupFile01">
              <label class="custom-file-label" for="inputGroupFile01">Scegli il file</label>
            </div>
          </div>
        </div>
         <div v-else class="form-group">
           <input type="button" class="btn" @click="cropImage" value="Ridimensiona">
          <vue-cropper :aspectRatio="1" :cropBoxResizable="false" :zoomable="false" :guides="true" :view-mode="2" drag-mode="move" ref="cropper" :src="image" alt="Source Image">
          </vue-cropper>
        </div>
        <!-- Fine immagine profilo -->
        <div class="form-group">
          <label for="coursePrice">Prezzo Corso</label>
          <input v-model="course.price" type="number" class="form-control" id="coursePrice" placeholder="Prezzo">
        </div>
        <button type="submit" class="btn btn-primary">Submit</button>
      </form>
    </div>
  </div>
</template>

<script>
import { firebase, database, storage } from '@/firebase'
import { getCurrentUser } from '@/helpers'
import router from '@/router'

import { quillEditor} from "vue-quill-editor"
import VueCropper from "vue-cropperjs"

export default {
  name: 'CourseAdd',
  components:{
    quillEditor,
    VueCropper,
  },
  data() {
    return {
      editorOption: {
        theme: 'snow'
      },
      crop: true,
      cropImg: '',
      image: '',
      course: {
        title: '',
        description: '',
        tldr: '',
        price: 0,
        teacher: null
      }
    }
  },
  methods: {
    add: async function() {
      // this.course.imgURL = this.cropImg

      // Set teacher
      let currentFirebaseUser = firebase.auth().currentUser
      console.log(currentFirebaseUser)
      this.course.teacher = await database.collection('Users')
        .doc(currentFirebaseUser.email)

      console.log(this.course)

      // Upload course to database
      let courseID
      await database.collection('Courses').add(this.course).then(result => {
          courseID = result.id
      })
      await storage.child("Courses/"+courseID+"/profile").putString(this.cropImg, 'data_url')
      // Redirect
      router.push('/courses')
    },
    onFileChange: function(e) {
      this.crop = false;
      let reader = new FileReader
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      reader.onload = (event) => {
        this.image = event.target.result;
        // rebuild cropperjs with the updated source
        this.$refs.cropper.replace(event.target.result);
      };
      reader.readAsDataURL(files[0]);
      //this.image = files[0]
      //this.createImage(files[0]);
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      //console.log(this.cropImg)
    },
  }
}
</script>

<style scoped>
#imgss {
  width: 1920px !important;
  height: 1080px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseAdd.vue